// Copyright (c) 2022 Move Closer

import { ProfileTabItem } from '../../profile/services/profile-tabs'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const loyaltyTabsItems: ProfileTabItem[] = []
